import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { XeroCopySource } from 'app/model/pipeline/copysource/xero.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(XeroCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class XeroCopySourceAdapter extends CopySourceAdapter<XeroCopySource, Model.XeroSource> {
    protected override async _toResource(copySource: XeroCopySource): Promise<Model.XeroSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(XeroCopySource).name);
    }

    protected override async _toModel(resource: Model.XeroSource, copyActivity: CopyActivity): Promise<XeroCopySource> {
        return this._toTabularModel(resource, copyActivity, XeroCopySource.MODEL);
    }
}
